import { EventEmitter, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import it to change locale and load localization messages
import { locale as devexLocale } from 'devextreme/localization';



@Injectable()
export class LanguageService {
  actualLanguage$: EventEmitter<any>;
  actualLanguage: any = 'en';
  actualDateFormat = 'DD/MM/YYYY, HH:mm:ss';

  constructor(
      private translate: TranslateService,
  ) {
      this.actualLanguage$ = new EventEmitter();
  }

  setUILanguage(locale): void {
    if (!locale) {
      locale = this.translate.getBrowserLang();
    }
    // Currently supported languages: en (english), pt (portuguese), es (spanish)
    // Any language different from this will reset to english
    if (locale !== 'en' && locale !== 'pt' && locale !== 'es') {
      locale = 'en';
    }
    this.translate.use(locale);
    devexLocale(locale);
    this.actualLanguage = locale;
    this.actualLanguage$.emit(locale);
    this.setActualDateFormat(locale);
  }

  private setActualDateFormat(locale: string) {
    switch (locale) {
      case 'en':
        this.actualDateFormat = 'MM/DD/YYYY, HH:mm:ss';
        break;
      case 'es':
        this.actualDateFormat = 'DD/MM/YYYY, HH:mm:ss';
        break;
      default:
        this.actualDateFormat = 'DD/MM/YYYY, HH:mm:ss';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/language.service.ts